import $ from "jquery";
import sortSelect from "../sortSelect";
import CheckboxFilters from "../checkbox-filters"; // eslint-disable-line

/**
 * Fetch search results
 * @param String url
 * @param Array data
 * @param DOMObject container
 */
const fetchResults = (url, data, container, el) => {
  const c = container;
  const d = data;
  let isFetching = false;

  if (!isFetching) {
    isFetching = true;
    c.classList.add("loading");

    // Append the loader
    $(c).append('<div class="la-ball-clip-rotate"><div></div></div>');

    // Fetch our results
    $.ajax({
      url,
      data: d || null,
      cache: false
    })
      .done(response => {
        c.innerHTML = response;
        c.classList.remove("loading");
        sortSelect();
        // Re init our checkbox filters on all pages except documents
        // as we are not injecting these into the DOM on documents library
        // like the other pages
        /* eslint-disable */
          if (!$(container).hasClass("document-results") ) {
            const consultationFilters = new CheckboxFilters(
              ".checkbox-toggle",
              ".listing-form",
              "[data-inject='search-results']",
              "checkbox-toggle--active"
            );

            // Get old element name
            const name = el.nextElementSibling.getAttribute("name");

            // Find new element and set the focus
            const checkboxInput = document.querySelector(`[name="${name}"]`);
            checkboxInput.previousElementSibling.focus();

          }
        /* eslint-enable */
        isFetching = false;
      })
      .fail(response => {
        console.warn(response);
      });
  }
};

export default fetchResults;
